import { render, staticRenderFns } from "./ProductSlideInPanel.vue?vue&type=template&id=5d8ff31c&lang=pug&"
import script from "./ProductSlideInPanel.vue?vue&type=script&lang=js&"
export * from "./ProductSlideInPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports